import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';

var buildHomeUrl = function buildHomeUrl() {
  return '/';
};

var CgvType = {
  PRO: 'cgv-pro',
  MARKETPLACE: 'cgv-marketplace',
  DEFAULT: 'cgv'
};

var buildCategoryUrl = function buildCategoryUrl(locale, slug, hash) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);
};

var buildProductUrl = function buildProductUrl(locale, slug, reference) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");
};

var buildStaticUrl = function buildStaticUrl(locale, slug, oldVersion) {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};

var buildSearchUrl = function buildSearchUrl(locale, query) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);
};

var buildEditoUrl = function buildEditoUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);
};

var buildMyAccountUrl = function buildMyAccountUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/user");
};

var buildFaqUrl = function buildFaqUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);
};

var buildContactFormUrl = function buildContactFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);
};

var buildReturnFormUrl = function buildReturnFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);
};

var buildCgvUrl = function buildCgvUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legale/").concat(CgvType[page] || CgvType.DEFAULT);
};

var buildCartUrl = function buildCartUrl(locale, mercureOpeningStatus) {
  return mercureOpeningStatus ? "/".concat(locale.market, "/").concat(locale.language, "/cart") : "/".concat(locale.market, "/").concat(locale.language, "/panier.html");
};

var buildDeliveryUrl = function buildDeliveryUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/delivery");
};

var buildLoginUrl = function buildLoginUrl(locale, isTunnel) {
  return isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/login") : "/".concat(locale.market, "/").concat(locale.language, "/login");
};

var buildSignupUrl = function buildSignupUrl(locale, isTunnel) {
  return isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/signup") : "/".concat(locale.market, "/").concat(locale.language, "/signup");
};

var buildPaymentUrl = function buildPaymentUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment");
};

var buildPaymentPaypalPendingUrl = function buildPaymentPaypalPendingUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-pending");
};

var buildPaymentConfirmedUrl = function buildPaymentConfirmedUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/confirmed");
};

var buildPaymentRefusedUrl = function buildPaymentRefusedUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/refused");
};

export var buildUrlForCheckout = {
  buildCartUrl: buildCartUrl,
  buildCgvUrl: buildCgvUrl,
  buildDeliveryUrl: buildDeliveryUrl,
  buildHomeUrl: buildHomeUrl,
  buildLoginUrl: buildLoginUrl,
  buildMyAccountUrl: buildMyAccountUrl,
  buildPaymentUrl: buildPaymentUrl,
  buildPaymentPaypalPendingUrl: buildPaymentPaypalPendingUrl,
  buildPaymentConfirmedUrl: buildPaymentConfirmedUrl,
  buildPaymentRefusedUrl: buildPaymentRefusedUrl,
  buildProductUrl: buildProductUrl,
  buildSignupUrl: buildSignupUrl
};
export default {
  methods: {
    buildCartUrl: buildCartUrl,
    buildCategoryUrl: buildCategoryUrl,
    buildContactFormUrl: buildContactFormUrl,
    buildEditoUrl: buildEditoUrl,
    buildFaqUrl: buildFaqUrl,
    buildProductUrl: buildProductUrl,
    buildReturnFormUrl: buildReturnFormUrl,
    buildSearchUrl: buildSearchUrl,
    buildStaticUrl: buildStaticUrl
  }
};